<div class="modal-header">
	<h2 class="modal-title" [innerHtml]="pageTitle"></h2>
	<button type="button" class="btn btn-close" aria-label="Close" (click)="close()" data-cy="CloseButton">
		<i class="fal fa-xmark"></i>
	</button>
</div>

<div class="modal-body">
	@if (formReady || isNewAccountGroupRule) {
		<rl-form-table-row [labelText]="'Rule Source'" [required]="true">
			<ng-template rlFormTableControl>
				<rl-dropdown-single [formControl]="form.controls.ruleSource" [options]="ruleSourceOptions"
					[showEmptyOption]="false" [dataLabel]="'RuleSourceDropdown'">
				</rl-dropdown-single>
			</ng-template>
		</rl-form-table-row>
		<!-- locked to Field Value for Amount: there is no Amount record, template or template group -->
		<rl-form-table-row [labelText]="'Rule Type'">
			<ng-template rlFormTableControl>
				<rl-dropdown-single [formControl]="form.controls.ruleType" [options]="ruleTypeOptions"
					[showEmptyOption]="true" [dataLabel]="'RuleTypeDropdown'">
				</rl-dropdown-single>
			</ng-template>
		</rl-form-table-row>
		@if(form.controls.ruleType?.value?.id === ruleTypes.FieldValue) {
			<!-- showEmptyOption so an unpicked field reads as "Select" instead of an empty box: nothing
				is preselected here for either source, and a blank select is indistinguishable from a
				dropdown with no options at all -->
			<rl-form-table-row [labelText]="'Picklist Field'">
				<ng-template rlFormTableControl>
					<rl-dropdown-single [formControl]="form.controls.picklist" [options]="triggerPicklistOptions"
						[showEmptyOption]="true" [dataLabel]="'triggerPicklistDropdown'">
					</rl-dropdown-single>
				</ng-template>
			</rl-form-table-row>
		}
		@if(form.controls.ruleType?.value?.id === ruleTypes.FieldValue && form.controls.picklist.value?.charValueSetID) {
			<rl-form-table-row [labelText]="'Trigger Value(s)'">
				<ng-template rlFormTableControl>
					<!-- Amount fields are hierarchies (Territory, Media), so they get the tree; Contact
						keeps the single-select it has always had. formControlValueMode stays the default
						"branchIds" -- the evaluator expands branches to leaves itself, and persisting
						leaves would break the rule the moment a child is added to the hierarchy. -->
					@if (isAmountSource) {
						<rl-tree-list-edit-control class="flex-grow-1" [formControl]="form.controls.picklistValues"
							[lovs]="lovs" [inactiveLovs]="inactiveLovs" [charValueGroups]="charValueGroups"
							[charValueGroupAssociations]="charValueGroupAssociations"
							[selectedValueIDs]="form.controls.picklistValues.value">
						</rl-tree-list-edit-control>
					} @else {
						<rl-dropdown-single [formControl]="form.controls.picklistValue"
							[options]="triggerPicklistValueOptions" [showEmptyOption]="false"
							[dataLabel]="'triggerPicklistValueDropdown'">
						</rl-dropdown-single>
					}
				</ng-template>
			</rl-form-table-row>
		}
		@if(form.controls.ruleType.value?.id === ruleTypes.Record) {
			<rl-form-table-row [labelText]="'Trigger Value - Select Contact Record'">
				<ng-template rlFormTableControl>
					@if(form.controls.contactRecord.value === null) {
						<rl-ap-contact-type-ahead class="flex-grow-1" [partyId]="accountGroup.partyId"
							[validTemplates]="triggerTemplateItems"
							(onTypeAheadSelected)="contactRecordTypeAheadAdd($event)" #typeAhead>
						</rl-ap-contact-type-ahead>
					} @else {
						<span [innerHTML]="form.controls.contactRecord.value.value"></span>
						<button data-cy="RemoveContactRecordButton" class="btn btn-icon btn-remove ng-star-inserted"
							[title]="'Remove ' + form.controls.contactRecord.value.value"
							(click)="clearContactRecord()">
							<i class="fal fa-xmark"></i>
						</button>
					}
				</ng-template>
			</rl-form-table-row>
		}
		@if(form.controls.ruleType.value?.id === ruleTypes.Template) {
			<rl-form-table-row [labelText]="'Trigger Value - Select Template'">
				<ng-template rlFormTableControl>
					<rl-dropdown-single [formControl]="form.controls.template" [options]="triggerTemplateOptions"
						[showEmptyOption]="false" [dataLabel]="'triggerTemplateDropdown'">
					</rl-dropdown-single>
				</ng-template>
			</rl-form-table-row>
		}
		@if(form.controls.ruleType.value?.id === ruleTypes.TemplateGroup) {
			<rl-form-table-row [labelText]="'Trigger Value - Select Template Group'">
				<ng-template rlFormTableControl>
					<rl-dropdown-single [formControl]="form.controls.templateGroup"
						[options]="triggerTemplateGroupOptions" [showEmptyOption]="false"
						[dataLabel]="'triggerTemplateGroupDropdown'">
					</rl-dropdown-single>
				</ng-template>
			</rl-form-table-row>
		}
	} @else {
		<div class="p-4 text-center">
			<rl-loader></rl-loader>
		</div>
	}
</div>

<div class="modal-footer">
	<button type="button" class="btn btn-light ms-auto" (click)="close()" data-cy="CancelButton">
		Cancel
	</button>
	<button (click)="save()" class="btn btn-success" [disabled]="!form?.valid || form?.pristine" data-cy="SaveButton">
		Save
	</button>
</div>